import { DEFAULT_HOURS_VALUE } from "../../constants";

export const subtractDaysFromHours = ({
    daysToSubtract,
    beforeStr,
    dayLengthStr = null,
}) => {
    if (
        beforeStr === undefined ||
        dayLengthStr === undefined ||
        parseFloat(daysToSubtract) <= 0
    ) {
        return {
            daysInHours: DEFAULT_HOURS_VALUE,
            resultHours: DEFAULT_HOURS_VALUE,
        };
    }
    const parseTime = (str) => {
        if (typeof str === "number") return str;
        return parseFloat(str.replace(",", "."));
    };

    const before = parseTime(beforeStr);
    const dayLength = parseTime(dayLengthStr);
    const totalToSubtract = daysToSubtract * dayLength;

    const diff = before - totalToSubtract;

    const formatSpecial = (value) => {
        const sign = value < 0 ? "-" : "";
        const abs = Math.abs(value);
        const hours = Math.floor(abs);
        const decimals = abs - hours;
        return `${sign}${hours},${String(Math.round(decimals * 100)).padStart(
            2,
            "0"
        )}`;
    };

    return {
        daysInHours: formatSpecial(totalToSubtract), // ex: "16,50"
        resultHours: formatSpecial(diff), // ex: "7,65"
    };
};
